import ServiceBase from './ServiceBase';

class LiveService extends ServiceBase {
  openClient(url) {
    url = url || this.store.state.liveSelect.client_url;
    if (this.store.state.commonSetting.pc_protocol_header != 'baijiacloud://') {
      url = url.replace('baijiacloud://', this.store.state.commonSetting.pc_protocol_header);
    }
    const { href } = this.router.resolve({
      name: 'DownloadClient',
      query: {
        url: url,
      },
    });
    this.store.commit('showSelectLive', {
      show: false,
    });
    if (this.store.state.commonSetting.is_live_new_tag == 1) {
      window.open(href);
    } else {
      document.location = href;
    }
  }
}

export default () => {
  return new LiveService();
};
